import React, { useRef, useState } from "react";
import {
  Box,
  Button,
  Divider,
  Fab,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
  Stack,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";

import "react-datepicker/dist/react-datepicker.css";
import { useEffect } from "react";

import {
  getEmpearningSalary,
  getUnpaidUser,
  viewPaymentSlip,
} from "../paymentReceipt/paymentReceiptApi";

import { useSelector } from "react-redux";
import { Navigate, useNavigate } from "react-router";
import AddPost from "./AddPost";
import { getAllJob } from "./jobsApi";
import Heading from "../../common/Heading";

const Posts = ({ clickappliedCandidate }) => {
  const navigate = useNavigate();

  const businessChooseTab = useSelector(
    (state) => state.reducer.businessChooseTab,
  );

  const [open, setOpen] = useState(false);
  const [modalData, setModalData] = useState(null);

  const [posts, setPosts] = useState();
  const userDetail = useSelector((state) => state.reducer.userDetail);

  let val = userDetail?.profileId?.split("?")[1];
  let billerId = Number(val?.split("=")[1]?.replace(/\D/g, ""));

  const getAllJobPosts = async () => {
    const payload = {
      billerId: billerId,
      filter: "",
      search: "",
    };

    //console.log("bbbb", billerId);

    getAllJob(payload, (data) => {
      //console.log("Job Postss ", data.data.data.list);
      setPosts(data.data.data.list);
    });
  };

  useEffect(() => {
    getAllJobPosts();
  }, []);

  const formatDate = (date) =>
    new Date(date)
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
      .replace(/ /g, "-");

  const tableGrid = {
    display: "grid",
    gridTemplateColumns: {
      md: "100px 200px 200px 140px 250px 200px 120px 120px 350px",
      sm: "100px 150px 150px 120px 200px 150px 100px 100px 300px",
      xs: "80px 120px 120px 100px 150px 120px 80px 80px 260px",
    },
    alignItems: "center",
  };
  const labelStyle1 = {
    // fontWeight: 600,
    // color: "#000",
    fontSize: { xs: "12px", sm: "13px", md: "15px" },
    // whiteSpace: "nowrap",
  };

  return (
    <>
      {/* <DynamicBreadcrumbs /> */}
      <Box
        px={{ xs: 2, sm: 4 }}
        pb={4}
        container
        sx={{
          paddingTop: "15px",
          backgroundColor: "#E3E3FF",
          fontFamily: "'Montserrat', sans-serif",
        }}
      >
        <Grid
          alignItems="center"
          container
          px={{ sm: 2, xs: 0 }}
          spacing={{ xs: 0, sm: 2 }}
        >
          <Grid item xs={12} sm={8} md={9} lg={10}>
            <Heading name="Posts" />
          </Grid>
          {/* <Grid
            item
            xs={12}
            sm={8}
            md={9}
            lg={10}
            sx={{
              background:
                "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
              padding: "10px",
              mt: "10px",
              borderRadius: "5px",
              color: "#01008B",
              textAlign: "left",
              // marginBottom: "20px",
              fontFamily: "'Montserrat', sans-serif",
              fontSize: "20px",
              fontWeight: 500,
            }}
          >
            <Typography
              variant="h6"
              fontSize={{
                xs: "12px",
                sm: "13px",
                md: "18px",
                md: "20px",
              }}
              fontWeight="500"
            >
              Posts
            </Typography>
          </Grid> */}

          <Grid
            item
            // md={2}
            xs={12}
            sm={4}
            md={3}
            lg={2}
            sx={{
              paddingRight: "0px",
            }}
          >
            <Button
              fullWidth
              onClick={() => {
                setModalData(null);
                setOpen(true);
              }}
              sx={{
                textTransform: "capitalize",
                // width: {
                //   xs: "100%",
                // },
                fontSize: { xs: "12px", sm: "13px", md: "15px" },

                // p: "10px",
                whiteSpace: "nowrap",
              }}
              color="primary"
              variant="contained"
              aria-label="add"
            >
              Add Job Post
              <AddIcon sx={{ marginLeft: "6px" }} />
            </Button>
          </Grid>
        </Grid>

        <AddPost
          getAllJobPosts={getAllJobPosts}
          setOpen={setOpen}
          open={open}
          modalData={modalData}
        />

        <Box
          sx={{
            backgroundColor: "white",
            px: 2,
            py: 2,
            mt: 2,
            borderRadius: "12px",
            overflow: "auto",
            height: "75vh",
          }}
        >
          <Box sx={{ minWidth: { md: "1780px", sm: "1500px", xs: "1200px" } }}>
            {/* HEADER */}
            <Box
              sx={{
                ...tableGrid,
                borderBottom: "1.5px solid black",
                p: "10px",
                px: 6,
              }}
            >
              <Box sx={{ ...labelStyle1, color: "#01008B", fontWeight: 500 }}>
                Post Id.
              </Box>
              <Box sx={{ ...labelStyle1, color: "#01008B", fontWeight: 500 }}>
                Post Creation Date
              </Box>
              <Box sx={{ ...labelStyle1, color: "#01008B", fontWeight: 500 }}>
                Salon
              </Box>
              <Box sx={{ ...labelStyle1, color: "#01008B", fontWeight: 500 }}>
                Designation
              </Box>

              <Box
                sx={{
                  ...labelStyle1,
                  textAlign: "center",
                  color: "#01008B",
                  fontWeight: 500,
                }}
              >
                Location
              </Box>

              <Box
                sx={{
                  ...labelStyle1,
                  textAlign: "left",
                  color: "#01008B",
                  fontWeight: 500,
                }}
              >
                Salary
              </Box>

              <Box
                sx={{
                  ...labelStyle1,
                  textAlign: "left",
                  color: "#01008B",
                  fontWeight: 500,
                }}
              >
                Vacancies
              </Box>

              <Box
                sx={{
                  ...labelStyle1,
                  textAlign: "center",
                  color: "#01008B",
                  fontWeight: 500,
                }}
              >
                Post Status
              </Box>
              <Box
                sx={{
                  ...labelStyle1,
                  textAlign: "center",
                  color: "#01008B",
                  fontWeight: 500,
                }}
              ></Box>
              <Box />
            </Box>

            {/* DATA ROW */}
            {posts?.map((job, index) => {
              return (
                <Box
                  sx={{
                    ...tableGrid,
                    backgroundColor: "#E8E8FF",
                    borderRadius: "8px",
                    mt: 1,
                    mb: 1,
                    p: 1,
                    px: 6,
                    width: "fit-content",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setModalData(job);
                    setOpen(true);
                  }}
                >
                  <Box sx={{ ...labelStyle1, fontWeight: "medium" }}>
                    {job.id}
                  </Box>
                  <Box sx={{ ...labelStyle1, fontWeight: "medium" }}>
                    {" "}
                    {formatDate(job.createdDate)}
                  </Box>
                  <Box sx={{ ...labelStyle1, fontWeight: "medium" }}>
                    {job.enterpriseName}
                  </Box>
                  <Box sx={{ ...labelStyle1, fontWeight: "medium" }}>
                    {job.designation}
                  </Box>

                  <Box
                    sx={{
                      ...labelStyle1,
                      textAlign: "center",
                      fontWeight: "medium",
                    }}
                  >
                    {job.preferredLocation}
                  </Box>

                  <Box sx={{ ...labelStyle1, textAlign: "left" }}>
                    {job.minSalary} - {job.maxSalary} per month
                  </Box>

                  <Box
                    sx={{
                      ...labelStyle1,
                      textAlign: "center",
                      fontWeight: "medium",
                    }}
                  >
                    {job.noOfVacancies}
                  </Box>

                  <Box
                    sx={{
                      ...labelStyle1,
                      textAlign: "center",
                      fontWeight: "medium",
                    }}
                  >
                    {job.status === 1 ? "Active" : "Inactive"}
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      // justifyContent: "center",
                      gap: 1,
                    }}
                  >
                    <Button
                      onClick={() => {
                        setModalData(job);
                        setOpen(true);
                      }}
                      variant="contained"
                      sx={{ ...labelStyle1, px: { md: 4, sm: 4, xs: 2 } }}
                    >
                      Edit
                    </Button>
                    <Button
                      onClick={() => {
                        clickappliedCandidate(job);
                      }}
                      variant="outlined"
                      sx={{
                        ...labelStyle1,
                        px: { md: 3, sm: 1, xs: 1, lg: 3 },
                      }}
                    >
                      Show Applied Candidates
                    </Button>
                  </Box>
                </Box>
              );
            })}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Posts;
